<template>
  <div class="home-container">
    <el-container>
      <el-header> <my-header></my-header> </el-header>
      <el-container>
        <el-aside width="200px">
          <el-menu
            :default-active="$route.path"
            :unique-opened="true"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            background-color="#334050"
            text-color="#fff"
            active-text-color="#ffd04b"
            router
          >
            <sidebar-item
              v-for="(route, index) in tmpRoute"
              :itemIndex="index"
              :isAdmin="true"
              :key="route.path"
              :item="route"
            />
          </el-menu>
          <!-- <img
            class="left menu-img"
            src="../../assets/images/home/home-menu.png"
          /> -->
        </el-aside>
        <el-main>
          <!--<router-view></router-view>-->
          <!-- <el-scrollbar style="height:100%"> -->
          <router-view name="blank"></router-view>
          <router-view></router-view>
          <!-- </el-scrollbar> -->
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "@/components/SidebarItem.vue";
export default {
  components: { SidebarItem },
  data() {
    return {
      tmpRoute: [
        {
          path: "/admin",
          redirect: "/admin/operation/appointment",
          name: "运营统计",
          meta: { title: "运营统计", icon: "menu_icon05.png", roles: "none" },
          has: "admin",
          children: [
            {
              path: "/admin/operation/appointment",
              name: "预约申请",
              meta: {
                title: "预约申请",
                roles: "none",
              },
            },
            {
              path: "/admin/operation/trail_phones",
              name: "试用申请",
              meta: {
                title: "试用申请",
                roles: "none",
              },
            },
            {
              path: "/admin/operation/cooperation",
              name: "合作伙伴申请",
              meta: {
                title: "合作伙伴申请",
                roles: "none",
              },
            },
            {
              path: "/admin/operation/xzUser",
              name: "小智用户",
              meta: {
                title: "小智用户",
                roles: "none",
              },
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    // menuItem: function () {
    //   // 动态获取可访问路由表
    //   this.$router.options.routes = this.$store.state.permission.addRouters;
    //   return this.$store.state.permission.addRouters;
    // },
  },
  computed: {
    // ...mapGetters(['permission_routes']),
  },
};
</script>

<style>
@import "../../assets/css/style.css";
/*主页导航start*/
.el-select {
  width: 100%;
}
.el-select-dropdown
  .scroll-opacity.el-scrollbar
  .el-scrollbar__bar.is-vertical {
  opacity: 1;
}
.home-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
}

.home-container .el-menu-item-group__title {
  padding: 0px !important;
}

.home-container .el-main {
  padding: 0px !important;
}
.el-dialog {
  margin-top: 0 !important;
}
.el-header {
  padding: 0px !important;
}

.el-container {
  height: 100% !important;
}

.el-aside {
  background-color: #334050;
}

.el-menu-item {
  border-left: 3px solid #233444 !important;
  background-color: #233444 !important;
}

.el-menu-item.is-active {
  border-left: 3px solid #f5c947 !important;
  background-color: rgba(80, 88, 93, 0.5) !important;
}

.el-menu-item:hover {
  border-left: 3px solid #ffd04b !important;
  background-color: rgba(80, 88, 93, 0.5) !important;
}

.el-submenu {
  width: 200px;
  border-bottom: 1px solid #233444 !important;
}

.el-menu-item-group__title {
  padding: 0px;
}

.menu-img {
  float: inherit;
  bottom: 0px;
  position: fixed;
}

.el-main {
  padding: 0px;
  background-color: #f3f3f6;
}
/*主页导航end*/
/*主页内容公共部分start*/

.home-main {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.main_title {
  margin: 15px 14px;
  height: 66px;
  min-width: 400px;
  line-height: 66px;
  background-color: #ffffff;
}

.title-cn {
  margin-left: 30px;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 38px;
  letter-spacing: 0px;
  color: #333333;
}

.title-en {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 38px;
  letter-spacing: 0px;
  color: #cccccc;
}

.main-container {
  margin: 0px 14px;
  height: 100%;
  background-color: #ffffff;
  /*width: 98%;*/
  position: absolute;
  top: 96px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

.el-scrollbar__wrap {
  overflow-x: hidden;
}
/*主页内容公共部分end*/
</style>



// WEBPACK FOOTER //
// src/components/admin/layout.vue